import script from "./CalculationResult.vue?vue&type=script&lang=ts&setup=true"
export * from "./CalculationResult.vue?vue&type=script&lang=ts&setup=true"

import "./CalculationResult.vue?vue&type=style&index=0&id=a20678e4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a20678e4"]])

export default __exports__